export enum Protocol {
  V2 = 'V2',
  V3 = 'V3',
  V4 = 'V4',
  MIXED = 'MIXED',
}
